export enum Roles{
    ADMIN = "ADMIN",
    PREPARER = 'PREPARER',
    REVIEWER = 'REVIEWER',
    SUPERADMIN = 'SUPERADMIN'
}